<template>
  <a-card v-if="visible">
    <a-descriptions title="订单信息">
      <a-descriptions-item label="订单号">{{
        info.orderNo
      }}</a-descriptions-item>
      <a-descriptions-item label="购买数量">{{ info.num }}</a-descriptions-item>
      <a-descriptions-item label="总价"
        >{{ info.rateSum }}(元)</a-descriptions-item
      >
      <a-descriptions-item label="商品代码">{{
        info.goodsCode
      }}</a-descriptions-item>
      <a-descriptions-item label="商品名称">{{
        info.goodsName
      }}</a-descriptions-item>
      <a-descriptions-item label="商品单价"
        >{{ info.goodsPrice }}(元)</a-descriptions-item
      >
      <a-descriptions-item label="购买时间">{{
        info.saleDate
      }}</a-descriptions-item>
      <a-descriptions-item label="支付状态">
        <a-tag class="render-tag" color="#ed4014" v-if="info.paySta == '-1'"
          >支付异常</a-tag
        >
        <a-tag class="render-tag" color="#19be6b" v-if="info.paySta == '0'"
          >支付成功</a-tag
        >
        <a-tag class="render-tag" color="#2db7f5" v-if="info.paySta == '1'"
          >等待支付</a-tag
        >
        <a-tag class="render-tag" color="#ed4014" v-if="info.paySta == '2'"
          >支付失败</a-tag
        >
        <a-tag class="render-tag" color="#c5c8ce" v-if="info.paySta == '3'"
          >取消支付</a-tag
        >
        <a-tag class="render-tag" color="#ff9900" v-if="info.paySta == '4'"
          >等待退款</a-tag
        >
        <a-tag class="render-tag" color="#19be6b" v-if="info.paySta == '5'"
          >退款成功</a-tag
        >
        <a-tag class="render-tag" color="#ed4014" v-if="info.paySta == '6'"
          >退款失败</a-tag
        >
        <a-tag class="render-tag" color="grey" v-if="info.paySta == '7'"
          >交易结束,不可退款</a-tag
        >
        <a-tag class="render-tag" color="#17233d" v-if="info.paySta == '8'"
          >未付款交易超时关闭</a-tag
        >
      </a-descriptions-item>
      <a-descriptions-item label="备注">{{ info.remark }}</a-descriptions-item>
    </a-descriptions>
    <a-divider />
    <a-descriptions title="支付信息">
      <a-descriptions-item label="支付类型">
        <a-tag
          class="render-tag"
          color="#2d8cf0"
          v-if="info.payType == 'alipay'"
          >支付宝</a-tag
        >
        <a-tag
          class="render-tag"
          color="#00cc00"
          v-if="info.payType == 'wechat'"
          >微信</a-tag
        >
        <a-tag
          class="render-tag"
          color="#35e4e4"
          v-if="info.payType == 'umspay'"
          >银联卡</a-tag
        >
      </a-descriptions-item>
      <a-descriptions-item label="支付流水号">{{
        info.payBillno
      }}</a-descriptions-item>
      <a-descriptions-item label="支付金额"
        >{{ info.dirtyAmount }}(元)</a-descriptions-item
      >
      <a-descriptions-item label="支付时间">{{
        info.payDatetime
      }}</a-descriptions-item>
    </a-descriptions>
    <div class="operation"><a-button @click="back">返回</a-button></div>
  </a-card>
</template>

<script>
export default {
  name: "ContractOrderInfo",
  props: {
    info: {
      type: Object,
      default: function() {
        return {};
      }
    },
    visible: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    back() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="less" scoped>
.gallery {
  display: flex;
  flex-wrap: wrap;
  .gallery-item {
    height: 100px;
    width: 100px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.operation {
  text-align: center;
  margin: 20px auto 5px;
}
</style>
